export default "assets/images/logo-cafe-de-paris-big-5745a481.png";